import { BaseModel } from '../../../shared/base/base.models';

export class Role {
    value?: string;
    description?: string;
    groups?: string;
    privileges?: Privilege[] | string[] = [];
    parent?: Role | string;
    systemRole?: boolean = false;
}

export class Privilege extends BaseModel {
    value?: string;
    description?: string;
    groups?: string;
    system?: boolean = false;
}